import React from 'react';
import type { AssetInspectionRecord } from 'actions/asset';
import type { MergedInspectionReport } from 'customHooks/useFetchInspectionReports';
import InspectionsSummaryReport from './InspectionsSummaryReport';

interface ChartInspectionOverlayProps {
  readonly assetId: number;
  readonly assetHubRefreshToken: number;
  readonly inspectionRecords?: readonly AssetInspectionRecord[];
  readonly recordsLoading?: boolean;
  readonly recordsError?: boolean;
  readonly inspectionReports: readonly MergedInspectionReport[];
  readonly reportsLoading: boolean;
  readonly reportsError: boolean;
  readonly onClose: () => void;
}

const ChartInspectionOverlay: React.FC<ChartInspectionOverlayProps> = ({
  assetId,
  assetHubRefreshToken,
  inspectionRecords,
  recordsLoading,
  recordsError,
  inspectionReports,
  reportsLoading,
  reportsError,
  onClose,
}) => (
  <div className="inspection-overlay">
    <button className="close-btn" type="button" onClick={onClose}>
      Chart
    </button>
    <InspectionsSummaryReport
      assetId={assetId}
      assetHubRefreshToken={assetHubRefreshToken}
      inspectionRecords={inspectionRecords}
      recordsLoading={recordsLoading}
      recordsError={recordsError}
      inspectionReports={inspectionReports}
      reportsLoading={reportsLoading}
      reportsError={reportsError}
    />
  </div>
);

export default ChartInspectionOverlay;
